<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<z-select v-if="typeList.length > 0" :options="typeList" v-model="params.goodsTypeId"  class="w150" @handleChange="handleOffset(0)"></z-select>
				<z-select :options="statusItems" v-model="params.sellStatus" class="w120 m-l-10" @handleChange="handleOffset(0)"></z-select>
				<z-select :options="recommendItems" v-model="params.recommend" class="w120 m-l-10" @handleChange="handleOffset(0)"></z-select>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入商品名称..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</div>
		<section class="news-list">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="(item,index) in columns" >
					{{item}}
					<!--<a 
						v-if="index==4"
						:class="[params.orderBy=='has_count:ASC'?'up-sort':params.orderBy=='has_count:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('has_count')">
					</a>-->
					<a 
						v-if="index==4"
						:class="[params.orderBy=='sell_count:ASC'?'up-sort':params.orderBy=='sell_count:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('sell_count')">
					</a>
					<a 
						v-if="index==5"
						:class="[params.orderBy=='price:ASC'?'up-sort':params.orderBy=='price:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('price')">
					</a>
					<a 
						v-if="index==7"
						:class="[params.orderBy=='l_time:ASC'?'up-sort':params.orderBy=='l_time:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('l_time')">
					</a>
				</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>
						<z-img-hover :src="item.face" width="80"></z-img-hover>
					</td>
					<td>{{item.name}}</td>
					<td>{{item.type_name}}</td>
					<td>{{item.sell_status | sellStatus}}</td>
					<!--<td><input class="input w60 text-center" type="number" :value="item.has_count" v-on:blur="handleSetCount(item.id, item.has_count)"/></td>-->
					<td>{{item.sell_count}}</td>
					<td>{{item.price | filterMoney}}</td>
					<td>
						<!--<mt-switch v-model="item.recommend" @change="handleSetRecommend(item.id, item.recommend ? true : false)">{{item.recommend ? '是':'否' }}</mt-switch>-->
						<el-switch
							  v-model="item.recommend"
							  on-text="是"
							  off-text="否"
							  on-color="#2BB673"
							  off-color="#ff4949"
							  @change="handleSetRecommend(item.id, item.recommend)"
							  >
						</el-switch>
					</td>
					<td>
						<span v-if="item.l_time">{{item.l_time | momentFmt}}</span>
						<span v-else></span>
					</td>
					<td class="operating">
						<a class="operat-btn" @click="showGoodsDetail(item.id)"><i class="icon-look"></i><span>预览</span></a>
						<!--<a class="operat-btn" @click="handleSellStatus(item.id, item.sell_status)">
							<div v-if="item.sell_status == 2">
								<i class="icon-down-shelves"></i>
								<span>下架</span>
							</div>
							<div v-if="item.sell_status == 3">
								<i class="icon-up-shelves"></i>
								<span>上架</span>
							</div>
						</a>-->
						<el-popover placement="top" width="200" :ref="'popover_status_'+index">
							<div class="z-popover">
								<div>确定要{{item.sell_status==2 ? '下架':'上架'}}此条数据?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleSellStatus(item.id,item.sell_status)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i :class="[item.sell_status ==2 ?'icon-down-shelves':'icon-up-shelves']"></i><span>{{item.sell_status==2 ? '下架':'上架'}}</span></a>
						</el-popover>
						<router-link  class="operat-btn" tag="a" :to="{ name: 'vGoodsEdit',query:{id:item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确定要删除此条数据?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDeleteGoods(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<!--<tr slot="datasource" v-show="list.list.length <= 0">
					<td colspan="20"><p class="p-20">暂无记录 (˘•ω•˘)</p></td>
				</tr>-->
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" tag="a" :to="{ name: 'vGoodsEdit'}">新建商品</router-link>
				</div>
			</z-table>
		</section>
		
		<z-popup :showModel="isPopupCode">
			<div slot="popup-cont" class="popup-cont b-r-5">
				<p class="btn-close fx-align" @click="handleClosePopupCode"><i class="icon-close"></i></p>
				<div id="qrcode"></div>
			</div>
		</z-popup>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	import { OPEN_URL } from '@/config.js'
	export default {
		name: 'Wares',
		components: {},
		data() {
			return {
				columns :['封面', '名称', '分类', '状态', '已售', '售价(元)', '首页推荐', '修改时间', '操作'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
					goodsTypeId: '',//分类
					sellStatus: '',//销售状态
					recommend: '',//是否推荐
					orderBy: "l_time:DESC",
				},
				statusItems: [{
					value: '',
					text: '请选择状态'
				}, {
					value: 2,
					text: '在售'
				}, {
					value: 3,
					text: '待上架'
				}],
				recommendItems: [{
					value: '',
					text: '推荐(全部)'
				}, {
					value: 1,
					text: '是'
				}, {
					value: 0,
					text: '否'
				}],
				typeParam: {
					offset: 0,//分页偏移量
					count: 50, //每页多少条
				},
				typeList: [],
				isPopupCode:false,
				qrcode:''
			}
		},
		filters: {
			//销售状态
			sellStatus(status) {
				switch(status) {
					case 1:
						return '待售';
						break;
					case 2:
						return '在售';
						break;
					case 3:
						return '待上架';
						break;
					case 4:
						return '已售完';
						break;
				}
			}
		},
		computed: {
			...mapState({
				list: state => state.vmall.goodsList,
				userInfo: state => state.users.userInfo
			})
		},
		mounted() {
			this.handleGetGoodsList();
			this.handleTypeList();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
				if(typeof(this.$refs['popover_status_' + index]) != "undefined") this.$refs['popover_status_' + index][0].doClose();
			},
			//预览
			showGoodsDetail(id) {
				let qrcodeUrl = `${OPEN_URL}/wares_detail?mid=${this.userInfo.mid}&goodsId=${id}&scope=snsapi_userinfo`
				if(this.qrcode) {
					this.qrcode.makeCode(qrcodeUrl);
					this.isPopupCode = true
					return; 
				}
             	this.qrcode = this.$qrcodeInit({
             		id: 'qrcode',
             		text: qrcodeUrl,
             		width: 300,
             		height: 300
             	});
             	this.isPopupCode = true
			},
			handleClosePopupCode(){
				this.isPopupCode = false
			},
			//排序
			handleListByOrder(orderBy) {
				if (this.params.orderBy == 'l_time:DESC') {
					this.params.orderBy = orderBy + ':ASC';
				} else {
					this.params.orderBy = this.params.orderBy == orderBy + ':ASC' ? orderBy + ':DESC' : orderBy + ':ASC';
				}
				
				this.params.offset = 0;
				this.handleGetGoodsList();
			},
			//上下架
			async handleSellStatus(id, status) {
				let params = {
						id,
						status: status == 2 ? 3 : 2
					};
				try{
					await this.setGoodsSellStatus(params)
					this.handleGetGoodsList()
					this.$success('操作成功');
				}catch(e){
					this.$errorMsg('操作失败')
				}
			},
			
			//获取商品列表
			handleGetGoodsList() {
				this.getGoodsList(this.params)
			},
			
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetGoodsList();
			},
			
			//新增或者编辑商品
			handleEdit(id = null) {
				this.$router.push({ name: 'editVmallGoods', query: { id: id }})
			},
			
			//删除商品
			async handleDeleteGoods(id) {
				try{
					await this.deleteGoods({id})
					this.handleGetGoodsList()
					this.$success('删除成功');
				}catch(e){
					this.$errorMsg(msg);
				}
			},
			
			//设置商品是否为推荐
			async handleSetRecommend(id, recommend) {
				let params = {
					id,
					recommend
				};
				try{
					await this.setGoodsRecommend(params)
					this.$success('操作成功')
					this.handleGetGoodsList();
				}catch(e){
					this.handleGetGoodsList();
					this.$errorMsg('操作失败');
				}
			},
			
			//获取商品分类
			handleTypeList() {
				this.getGoodsTypeList(this.typeParam).then((data)=>{
					if (data.length > 0) {
						this.typeList = data;
						this.typeList.unshift({value: "", text: '请选择分类'});
					}
				},(msg)=>{
					this.$errorMsg(msg);
				})	
			},
			...mapActions(['getGoodsList', 'deleteGoods', 'setGoodsRecommend', 'setGoodsSellStatus', 'saveGoodsCount', 'getGoodsTypeList']), // 引入action
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.popup-cont{
		width: 320px;
		height:320px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform-origin: 0% -20%;
		padding: 10px;
		.btn-close{
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i{
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active{
				i{
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
	}
	.operating .operat-btn{
		.icon-del,.delete{
			height: 20px !important;
		}
	}
	.news-list {
		li {
			+ li {
				border-top: 1px solid #ddd;
			}
			a {
				color: $color-font;
				padding: px-em(16px) 0;
				&:hover {
					background: rgba(0, 0, 0, .07);
				}
				.time {
					color: $color-7a7a7a;
				}
				.c-g {
					color: $color-gray;
				}
			}
		}
		.arrow{
			position: relative;
			&:before,&:after{
				content: "";
				position: absolute;
				width: 0;
    			height: 0;
			}
			&:before{
				border-left: 3px solid transparent;
			    border-right: 3px solid transparent;
			    border-bottom: 6px solid $color-gray;
			    top: -0;
			    left: 0;
			}
			&:after{
				border-left: 3px solid transparent;
			    border-right: 3px solid transparent;
			    border-top: 6px solid $color-gray;
			    bottom: -0px;
			    left: 0;
			}
			&.up-sort{
				&:before{
					border-bottom-color: $color-main;
				}
			}
			&.down-sort{
				&:after{
					border-top-color: $color-main;
				}
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1400px);
		}	
	}
</style>


// WEBPACK FOOTER //
// Goods.vue?1173d7a0